export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const EDIT_PROFILE = "EDIT_PROFILE"
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";
export const GET_PROFILE_DETAIL = "GET_PROFILE_DETAIL"
export const GET_PROFILE_DETAIL_SUCCESS = 'GET_PROFILE_DETAIL_SUCCESS'
